import React from "react"
import cx from "classnames"

import SimpleP from "../../components/block-content/simpleP"
import Button from "../button"

import styles from "./productItemsSection.module.scss"

const ProductItemsSection = ({ productItems }) => (
  <section className={styles.productItems}>
    {productItems.map((productItem, i) => {
      const itemWidthClass = productItem.itemWidth && productItem.itemWidth === "1/3" ? styles.itemWidth30 : productItem.itemWidth && productItem.itemWidth === "1/2" ? styles.itemWidth50 : productItem.itemWidth && productItem.itemWidth === "fullWidth" ? styles.itemWidthFull : "";
      return (
        <div
          className={cx(styles.productItem, itemWidthClass)}
          key={productItem.id + String(i)}
          style={{ backgroundColor: productItem.color }}
          id={productItem.item_id}
        >
          {productItem?.tagLabel && (
            <div className={styles.productItemTag}>{productItem.tagLabel}</div>
          )}
          <div className={styles.productItemHeading}>
            {productItem._rawLogo && (
              <div className={styles.productItemIcon}>
                <img
                  src={productItem._rawLogo.image.asset.url}
                  alt={productItem._rawLogo.alt}
                />
              </div>
            )}
            <div>{productItem.title}</div>
          </div>
          {productItem?.descriptionTitle && (
            <h3 className={styles.productItemDescriptionTitle}>{productItem?.descriptionTitle}</h3>
          )}
          {productItem.description && (
            <SimpleP blocks={productItem.description} />
          )}
          {productItem.ctaButton.link.map((link, i) => (
            <div className={styles.productItemLink} data-type="primaryVariant2" key={link?._key ?? String(i)}>
              <Button to={link.link} label={link.title} type={link.type} />
            </div>
          ))}
          {productItem._rawImage && (
            <div className={styles.productItemImage}>
              <img
                src={productItem._rawImage.image.asset.url}
                alt={productItem._rawImage.alt}
              />
            </div>
          )}
        </div>
    )})}
  </section>
)

export default ProductItemsSection
